export const getters = {
	operations: state => state.operations,
	operation: state => id => { return state.operations.filter(o => (parseInt(o.id) === parseInt(id)))[0] },
	getContractTypeList: state => state.contracts,
	getProductTypeList: state => state.products
}



// WEBPACK FOOTER //
// ./src/common/store/Transactions/getters.js